<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [fullScreen]="true"
  (onHiding)="closeDialog()"
  [(visible)]="openDialog"
>
  <form>
    <div class="row mg-t-10">
      <div class="col-md-12">
        <i class="pi pi-info-circle"></i> Chaque plat sélectionné sera associé au modèle de conditionnement plat actuel
        ainsi que les unités de production associés à ce dernier. Les plats déjà associés pour ce modèle de conditionnement plat ou dans d'autres modèles de conditionnement plat ne s'afficheront pas à l'écran.
      </div>
    </div>
    <div class="row mg-t-10">
      <div class="col-lg-4">
        <dx-tag-box
          #dxTypeFab
          placeholder="Filtrer les plats par type de fabrication..."
          (onValueChanged)="onChangeTypeFabricationFilter($event)"
          [dataSource]="allTaches"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
      <div class="col-lg-4">
        <dx-tag-box
          #dxRegime
          placeholder="Filtrer les plats par régime..."
          (onValueChanged)="onChangeRegimeFilter($event)"
          [dataSource]="allRegimes"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
      <div class="col-lg-4">
        <dx-tag-box
          #dxSites
          placeholder="Filtrer les plats par site..."
          (onValueChanged)="onChangeSiteFilter($event)"
          [dataSource]="sitesUtilisateurConnecte"
          [showSelectionControls]="true"
          displayExpr="libelle"
          valueExpr="id"
          [searchEnabled]="true"
          applyValueMode="instantly">
        </dx-tag-box>
      </div>
    </div>
    <div class="row mg-t-10">
      <div class="col-lg-4">
        <dx-drop-down-box
          #dxFamilleProduit
          [(value)]="treeBoxValue"
          valueExpr="id"
          displayExpr="name"
          placeholder="Filtrer les plats par famille de produit..."
          [showClearButton]="true"
          [dataSource]="treeDataSource"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              #dxTreeView
              [dataSource]="allFamillesProduits"
              dataStructure="plain"
              keyExpr="id"
              parentIdExpr="parent.id"
              selectionMode="multiple"
              showCheckBoxesMode="normal"
              [selectNodesRecursive]="true"
              displayExpr="libelle"
              [selectByClick]="true"
              (onItemSelectionChanged)="onChangeParentDenreeSelection($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </div>
      <div class="col-md-4">
        <dx-text-box #dxCode placeholder="Filtrer les plats par code..." valueChangeEvent="keyup"
                     (onValueChanged)="onChangeCodeFilter($event)">
        </dx-text-box>
      </div>
      <div class="col-md-4">
        <dx-text-box #dxLabel placeholder="Filtrer les plats par libellé..." valueChangeEvent="keyup"
                     (onValueChanged)="onChangePlatLibelleFilter($event)">
        </dx-text-box>
      </div>
    </div>
    <div class="row mg-t-10">
      <div class="col-md-12">
        <div class="p-inputgroup input-group-sm ">
          <dx-data-grid
            [dataSource]="dataSource"
            keyExpr="id"
            [height]="'70vh'"
            [hoverStateEnabled]="true"
            [rowAlternationEnabled]="true"
            [allowColumnResizing]="true"
            [showRowLines]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            (onSelectionChanged)="checkDisabledButtons()"
            (onCellClick)="cellClick($event)"
            #gridPlatsToAdd>

            <dxo-selection [deferred]="true" [allowSelectAll]="true" [showCheckBoxesMode]="checkBoxesMode"
                           mode="multiple"></dxo-selection>

            <dxi-column dataField="site.libelle" caption="Site" cellTemplate="siteCellTemplate"
                        [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="libelle" caption="Nom du plat" [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="declinaisons" cellTemplate="pdCellTemplate" caption="Déclinaison(s)"
                        [allowFiltering]="false"></dxi-column>
            <dxi-column dataField="code" caption="Code" [allowFiltering]="false"></dxi-column>

            <div *dxTemplate="let cell of 'siteCellTemplate'">
              <yo-site [siteId]="cell.row.data.site.id" [siteLibelle]="cell.row.data.site.libelle"
                       [yoDelayMsTooltip]="1500"></yo-site>
            </div>

            <div class="flex-wrap" *dxTemplate="let cell of 'pdCellTemplate'">
              <label *ngFor="let d of cell.row.data.declinaisons" class="badge badge-secondary zoom cursor">
                {{ d?.libelle }}
              </label>
            </div>

            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-paging [pageSize]="isUsingFilter ? 10000 : 200"></dxo-paging>

            <dxo-pager
              [showPageSizeSelector]="true"
              [allowedPageSizes]="[20, 50, 100]"
              [showNavigationButtons]="false"
              [visible]="true"
              [showInfo]="true"
              infoText="{2} plat(s)">
            </dxo-pager>

          </dx-data-grid>

        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end" style="margin-top: 15px">
      <yo-button
        iconClass="fas fa-plus"
        label="Ajouter"
        (onClick)="save()"
        [disabled]="!canSave()">
      </yo-button>
      <yo-button
        class="mg-l-5"
        buttonClass="cta-delete"
        (onClick)="closeDialog()"
        iconClass="fas fa-times"
      >
      </yo-button>
    </div>
  </form>
</dx-popup>
